"use client";
import React from "react";
import SearchFormDesktop from "../SearchFormDesktop";
import SearchFormMobile from "../SearchFormMobile";
import useVehicleToggle from "../useVehicleToggle";
import VehicleTypeToggle from "../VehicleTypeToggle";

const SearchPill = ({ type, seoCity = null, initialTypes = null }) => {
  const isHeaderType = type === "header";
  const { selectedItems, toggleSelection } = useVehicleToggle({
    syncToRedux: !isHeaderType,
    initialTypes: isHeaderType ? null : initialTypes,
  });

  if (isHeaderType) {
    return (
      <div className="flex flex-col items-center justify-center w-full max-h-[44px]">
        <SearchFormDesktop type="header" />
      </div>
    );
  }

  const isSearchType = type === "search";

  return (
    <>
      <div
        data-search-pill
        className={`flex flex-col items-center justify-center relative z-10
          ${isSearchType ? 'w-auto mt-[100px]' : 'w-full mt-[100px] lg:w-[90%] lg:mt-[150px]'}`}
      >
        <VehicleTypeToggle
          selectedItems={selectedItems}
          toggleSelection={toggleSelection}
          variant="onDark"
          className="mt-2.5 mb-3 z-[8] gap-5 lg:mb-[30px] lg:gap-6"
        />
        <SearchFormDesktop type={type} seoCity={seoCity} />
        <SearchFormMobile type={type} seoCity={seoCity} />
      </div>
    </>
  );
};

export default SearchPill;
